import React, { useEffect, cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setSoundAction, playSoundAction, clearSoundAction } from "../../../../redux/sound";
import { setAnsweringQuestionsAction, clearAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import Closer from "./Closer";
import Inputer from "./Inputer";

const TutorialInitializer = ( props ) => {

  const dispatch = useDispatch();
  const setSound = payload => { dispatch( setSoundAction( payload ) ) };
  const playSound = () => { dispatch( playSoundAction() ) };
  const clearSound = () => { dispatch( clearSoundAction() ) };
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const clearAnsweringQuestions = () => { dispatch( clearAnsweringQuestionsAction() ) };

  const { t } = useTranslation();

  useEffect( () => {
    setAnsweringQuestions( {
      data : {
        stgNm : t( 'LC_05_17.msg001' ),
        totQstCt : 10,
        textCn : t( 'LC_05_17.msg002' )
      },
      answeringCount : 1
    } );
    setSound( { src : `${ process.env.PUBLIC_URL }/static/audio/lc_05_02_open.ogg` } );
    playSound();

    const entryClosePopupID = setTimeout(() => {
      setAnsweringQuestions( {
        isShowEntryClosePopup : true
      });
    }, 2000);

    return () => {
      setTimeout( () => {
        clearAnsweringQuestions();
        clearSound();
        clearTimeout(entryClosePopupID);
      } );
    };
  }, [] );

  return cloneElement( props.children || <Fragment />, {
    Closer,
    Inputer
  } );

};

export default TutorialInitializer;
